/**
 * 使用簿 PDF 表紙の表示設定（ブラウザ localStorage）。
 * クラウド／ローカル共通。サーバーは生成時に同じキー形を受け取る。
 */

export type UsageLedgerPdfCoverPrefs = {
  showLogo: boolean;
  showBrandHeader: boolean;
  showOrgCard: boolean;
  showToc: boolean;
  showCoverNote: boolean;
  showSignLines: boolean;
  /** 空ならプロフィール／Local 既定を使う */
  organizationName: string;
  departmentName: string;
  preparedBy: string;
};

export const USAGE_LEDGER_PDF_COVER_STORAGE_KEY = 'sample-manager.usageLedgerPdfCover';

export const DEFAULT_USAGE_LEDGER_PDF_COVER_PREFS: UsageLedgerPdfCoverPrefs = {
  showLogo: true,
  showBrandHeader: true,
  showOrgCard: true,
  showToc: true,
  showCoverNote: true,
  showSignLines: true,
  organizationName: '',
  departmentName: '',
  preparedBy: '',
};

function asBool(value: unknown, fallback: boolean): boolean {
  if (typeof value === 'boolean') return value;
  if (value === 'true' || value === '1') return true;
  if (value === 'false' || value === '0') return false;
  return fallback;
}

export function loadUsageLedgerPdfCoverPrefs(): UsageLedgerPdfCoverPrefs {
  const base = { ...DEFAULT_USAGE_LEDGER_PDF_COVER_PREFS };
  if (typeof localStorage === 'undefined') return base;
  try {
    const raw = localStorage.getItem(USAGE_LEDGER_PDF_COVER_STORAGE_KEY);
    if (!raw) return base;
    const o = JSON.parse(raw) as Record<string, unknown>;
    return {
      showLogo: asBool(o.showLogo, base.showLogo),
      showBrandHeader: asBool(o.showBrandHeader, base.showBrandHeader),
      showOrgCard: asBool(o.showOrgCard, base.showOrgCard),
      showToc: asBool(o.showToc, base.showToc),
      showCoverNote: asBool(o.showCoverNote, base.showCoverNote),
      showSignLines: asBool(o.showSignLines, base.showSignLines),
      organizationName: typeof o.organizationName === 'string' ? o.organizationName : '',
      departmentName: typeof o.departmentName === 'string' ? o.departmentName : '',
      preparedBy: typeof o.preparedBy === 'string' ? o.preparedBy : '',
    };
  } catch {
    return base;
  }
}

export function saveUsageLedgerPdfCoverPrefs(prefs: UsageLedgerPdfCoverPrefs): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(USAGE_LEDGER_PDF_COVER_STORAGE_KEY, JSON.stringify(prefs));
}

/** API に渡す表紙オンオフ（文言オーバーライドは issuer 側） */
export function coverPrefsToApiOptions(prefs: UsageLedgerPdfCoverPrefs) {
  return {
    showLogo: prefs.showLogo,
    showBrandHeader: prefs.showBrandHeader,
    showOrgCard: prefs.showOrgCard,
    showToc: prefs.showToc,
    showCoverNote: prefs.showCoverNote,
    showSignLines: prefs.showSignLines,
  };
}
